import React from 'react';
import { Skeleton } from '../skeleton/Skeleton';
import { Divider } from '../divider/Divider';

export const InventoryCarouselSkeleton = () => {
	return (
		<div className="relative h-full sm:w-[400px] xl:w-[800px]">
			<div className="flex flex-col h-full bg-tablz-dark-gray-1">
				{/* Mobile header skeleton */}
				<div className="sm:hidden border-b border-tablz-med-gray-4 p-2 bg-tablz-dark-gray-2">
					<div className="flex justify-between px-3 items-center">
						<Skeleton height="20px" width="200px" />
						<Skeleton height="32px" width="32px" style={{ borderRadius: '8px' }} />
					</div>
				</div>
				<div className="flex flex-col margin-x-auto relative bg-tablz-dark-gray-1 sm:pt-8 sm:pb-3 sm:px-5 overflow-hidden h-full">
					{/* Desktop title skeleton */}
					<div className="hidden sm:inline px-4">
						<Skeleton height="28px" width="180px" />
					</div>
					{/* Card skeletons - 4 cards in 2-col grid */}
					<div className="grid grid-cols-1 xl:grid-cols-2 gap-4 px-5 py-6 sm:px-0 sm:py-0 sm:pt-8">
						<Skeleton height="240px" width="100%" style={{ borderRadius: '12px' }} />
						<Skeleton height="240px" width="100%" style={{ borderRadius: '12px' }} />
						<Skeleton height="240px" width="100%" style={{ borderRadius: '12px' }} />
						<Skeleton height="240px" width="100%" style={{ borderRadius: '12px' }} />
					</div>
					<div className="hidden sm:block my-8">
						<Divider />
					</div>
					<div className="bg-tablz-dark-gray-2 flex gap-5 py-5 flex-col sm:bg-inherit sm:py-0 sm:px-0 sm:w-full">
						<div className="px-4 sm:px-0">
							<Skeleton height="28px" width="320px" />
						</div>
						<div className="flex gap-4 px-4 sm:px-0 overflow-hidden">
							<div className="shrink-0 sm:min-w-[min(370px,90vw)] sm:max-w-[370px]">
								<Skeleton height='240px' width='100%' style={{ borderRadius: '12px' }} />
							</div>
							<div className="shrink-0 sm:min-w-[min(370px,90vw)] sm:max-w-[370px]">
								<Skeleton height='240px' width='100%' style={{ borderRadius: '12px' }} />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
